<template>
  <BModal :id="modalId" :title="entityName + 'の削除'">
    <p>{{ dataName }} を削除します。よろしいですか？</p>
    <template #modal-footer>
      <div class="text-right">
        <a href="#" @click.prevent="hide">キャンセル</a>
        <span class="mx-2"></span>
        <button class="action-button btn btn-danger btn-rounded" type="button" @click="onDelete">削除する</button>
      </div>
    </template>
  </BModal>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'
import { BModal } from 'bootstrap-vue-next'
import { useModal } from '../composables/useModal'

const props = defineProps({
  modalId: {
    type: String,
    required: true
  },
  entityName: {
    type: String,
    required: true
  },
  dataName: {
    type: String,
    required: true
  }
})

const emit = defineEmits(['delete'])
const modal = useModal()

const hide = () => {
  modal.hide(props.modalId)
}

const onDelete = () => {
  hide()
  emit('delete')
}
</script>

<style scoped>

</style>
